import { useState } from "react";

import Wrapper from "../utils/wrapper";
import FilterButton from "../utils/filterButton";
import Menu from "../utils/menu";

import { Card, Modal, Button, InputText, Dropdown, Tooltip } from "@components";
import { Trash, ExternalLink, LayoutGrid, AlignLeft, Star } from "lucide-react";

import { Comparator } from "../comparator";

export function VillesSearchBar({ children, selectedItems, onDeselectAll }) {}
